import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { connect } from 'react-redux';
import { CategoryID, SeoMetaPayload } from '@sbt-web/network/types';
import { formatDistance, getGeoLevel, TuttaItalia } from '@sbt-web/utils';
import type { RootState } from '@/reducers/index';
import type { SearchState } from '@/reducers/search';
import { getVehiclesLabel } from '../helpers/automotive';
import { capitalizeFirst, capitalizeOnlyFirst } from '../helpers/common';
import { getGeoLabel, SEOTag } from '../helpers/geo';
import AdsCount from './AdsCount';
import ownClasses from './ListingHeading.module.scss';
interface StateProps {
  search: SearchState;
  totalAds: number;
}
interface OwnProps {
  seo?: SeoMetaPayload;
}
type Props = OwnProps & StateProps;
function buildText(search: SearchState, seo?: SeoMetaPayload): string {
  if (seo?.h1) {
    return seo.h1;
  }
  const adsLabel = search.query || 'Annunci';
  let geoLabel: string;
  if (search.radiusSearch == null) {
    const geoLevel = getGeoLevel(search.geo, search.searchNearRegions);
    geoLabel = getGeoLabel(search, geoLevel, SEOTag.H1);
  } else {
    const distanceLabel = formatDistance(search.radiusSearch.radiusMeters);
    const reference = search.radiusSearch.friendlyName != null ? `da ${search.radiusSearch.friendlyName}` : 'dal punto che hai selezionato';
    geoLabel = `entro ${distanceLabel} ${reference}`;
  }
  const vehiclesLabel = getVehiclesLabel(search);
  const categoryLabel = capitalizeOnlyFirst(getCategoryLabel(search));
  const categoriesToCapitalize: CategoryID[] = [CategoryID.Auto, CategoryID.Moto];
  if (vehiclesLabel && categoriesToCapitalize.includes(search.category.id)) {
    return capitalizeFirst(`${vehiclesLabel} ${geoLabel}`);
  }
  if (search.category.id === CategoryID.Tutte) {
    return capitalizeFirst(`${adsLabel} ${geoLabel}`);
  } else if (search.geo.region === TuttaItalia && search.radiusSearch == null) {
    return capitalizeFirst(`${adsLabel} in ${categoryLabel}`);
  } else {
    return capitalizeFirst(`${adsLabel} in ${categoryLabel} ${geoLabel}`);
  }
}
function getCategoryLabel(search: SearchState): string {
  if (search.category.id === CategoryID.Tutte || !search.category.label) {
    return '';
  }
  return search.category.label;
}
function ListingHeadingComponent(t0) {
  const $ = _c(12);
  const {
    totalAds,
    search,
    seo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classnames("listing-heading", ownClasses["listing-heading"]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== totalAds) {
    t2 = <AdsCount>{totalAds}</AdsCount>;
    $[1] = totalAds;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== search || $[4] !== seo) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /\s\s+/g;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = buildText(search, seo).trim().replace(t4, " ");
    $[3] = search;
    $[4] = seo;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <h1 className="headline-6">{t3}</h1>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
  search: state.search,
  seo: ownProps.seo,
  totalAds: state.items.total
});
const ListingHeading = connect(mapStateToProps)(ListingHeadingComponent);
export { ListingHeading, ListingHeadingComponent };